import { deepLinkObjCreation, getItem, setItem } from '../utils/common';
import { store } from '../store';
import { registerDeviceToken, setDynamicLinkParams } from '../actions/App/action';
import { DeviceRegister } from '../models/home/DeviceRegister.model';
import { isPlatform } from '@ionic/react';
import { Device } from '@capacitor/device';
import { FirebasePush } from 'fpc-custom-plugin-firebase-notification';
import { FPC_FCM_DUMMY_URL } from './constants';
import { SaveDeepLinkURI } from 'app/actions/Login/action';


export const usePushNotification = () => {
  let userDetails: {
    memberDetailsResponse:any
  };
  const registerPush = (_userDetails: any) => {
    userDetails = _userDetails;
    // Register with Apple / Google to receive push via APNS/FCM
    FirebasePush.requestPermissions().then((response: any) => {
      FirebasePush.register();
    }
    );
    addPushListeners();
  };

  const addPushListeners = () => {
    // FirebasePush.removeAllListeners();
    // On succcess, we should be able to receive notifications
    FirebasePush.addListener(
      'token',
      async (tokenResult: any) => {
        try {
          // 1. when app launch call GetDevice token method - getDeviceToken().
          let deviceToken = await getItem('deviceToken');
          let newToken = '';
          newToken = tokenResult.token;
          console.log(
            'App Push Registration Done: device Token from Device',
            tokenResult.token
          );

          if (deviceToken.value !== newToken) {
            console.log(
              'App Push Registration Done.:First App Launch',
              newToken
            );
            const deviceID = await Device.getInfo();
            const deviceRegister = new DeviceRegister();
            await setItem('deviceToken', newToken); //
            deviceRegister.uuid = (await Device.getId()).identifier;
            deviceRegister.upn = getUserPrincipalName(userDetails);
            deviceRegister.carrierId = getUserCarrierID(userDetails); //"TruckStop11234";
            deviceRegister.deviceOs = deviceID.operatingSystem;
            deviceRegister.deviceOsVersion = deviceID.osVersion;
            deviceRegister.email = getUserEmail(userDetails); //"abc@schneider.com";
            deviceRegister.phone = getUserMobile(userDetails);
            deviceRegister.deviceToken = newToken;

            // TODO : deviceID.uuid
            store.dispatch(
              registerDeviceToken(deviceRegister.getRequestPayload())
            );
          }
          console.log('App Push Registration Done.:Sub Sequent App Launch');
          // deviceToken = await getItem('deviceToken');
        } catch (e) {
          console.error('App Registration Catch Error.', e);
        }
      }
    );

    // Some issue with your setup and push will not work
    // FirebasePush.addListener('registrationError', (error: any) => {});

    // Show us the notification payload if the app is open on our device
    FirebasePush.addListener(
      'message',
      (notification: any) => {
        console.log(
          'pushNotificationReceived, message:' + JSON.stringify(notification)
        );

        // notification.title and body added when app is backgrounded or killed and notification is tapped
        notification = notification.title ? notification : notification.notificationTitle && { ...notification, title: notification.notificationTitle };
        notification = notification.body ? notification : (notification.notificationBody
           ? { ...notification, body: notification.notificationBody } : { ...notification, body: "" });

        presentAlertConfirm(notification);
      }
    );
  };

  const presentAlertConfirm = (notification: any) => {
    const alert = document.createElement('ion-alert');
    alert.cssClass = "alert-custome-buttons";
    alert.header = (isPlatform('ios') ? notification.aps.alert.title : notification.title) || 'Driver Assigned';
    alert.message = `${isPlatform('ios') ? notification.aps.alert.body || '' : notification.body}`;
    alert.mode = "ios";
    alert.buttons = [
      {
        text: 'View Later',
        role: 'Cancel',
        cssClass: 'secondary-cta-btn-mobile',
        handler: () => null
      },
      {
        text: 'View Now',
        role: 'Ok',
        cssClass: 'primary-cta-btn-mobile ml',
        handler: () => {
          if (notification.type == "MANAGE_USER_REQUEST") {
            store.dispatch(SaveDeepLinkURI(notification));
          } else {
            if (notification.deepLinkURI.indexOf("?") >= 0) {
              const deepLinkURL = FPC_FCM_DUMMY_URL + notification.deepLinkURI;
              const params = (new URL(deepLinkURL)).searchParams;
              const deepLinkURI = params.get('deepLinkURI');
              const paramsDict = params.get('params');
              store.dispatch(setDynamicLinkParams({
                paramsDict: paramsDict ? {
                  ...deepLinkObjCreation(paramsDict)
                } : null,
                deepLinkURI: deepLinkURI
              }));
            } else {
              const deepLinkURI = "/app/MyLoad";
              const paramsDict = { shipmentId: notification.shipmentId };
              store.dispatch(setDynamicLinkParams({
                paramsDict: paramsDict,
                deepLinkURI: deepLinkURI
              }));
            }
          }
        }
      },
    ];

    document.body.appendChild(alert);
    return alert.present();
  };
  const unRegisterPush = () => {
    FirebasePush.unregister();
  };

  return {
    registerPush,
    unRegisterPush
  };
};
const getUserPrincipalName =(userDetails:any)=>{
return (userDetails && userDetails.memberDetailsResponse &&
  userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn) || '';
}
const getUserCarrierID = (userDetails:any)=>{
  return (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId) || '';
}
const getUserEmail =(userDetails:any)=>{
  return userDetails && userDetails.memberDetailsResponse &&
  userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.email;
}
const getUserMobile =(userDetails:any) => {
  return (userDetails ? (userDetails.memberDetailsResponse && userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.mobileNumber && userDetails.memberDetailsResponse.member.mobileNumber.trim().replace('+', '')) : "");//"635214789";
}